/* eslint-disable no-param-reassign */
const PAGE_SIZES = {
  default: 6,
  sm: 8,
  lg: 18,
};

const MEDIA_QUERIES = {
  sm: window.matchMedia('(min-width: 481px)'),
  lg: window.matchMedia('(min-width: 1024px)'),
};

function getPageSize() {
  if (MEDIA_QUERIES.lg.matches) {
    return PAGE_SIZES.lg;
  }

  if (MEDIA_QUERIES.sm.matches) {
    return PAGE_SIZES.sm;
  }

  return PAGE_SIZES.default;
}

function getVisibleCards(cards, activeFilter) {
  if (activeFilter === 'all') {
    return cards;
  }

  return cards.filter((card) => card.dataset.category === activeFilter);
}

function setActiveFilterButton(buttons, activeButton) {
  buttons.forEach((button) => {
    const isActive = button === activeButton;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
}

function updateFilterScrollHint(navEl, filterEl) {
  const maxScroll = navEl.scrollWidth - navEl.clientWidth;
  const hasOverflow = maxScroll > 1;
  const { scrollLeft } = navEl;

  filterEl.classList.toggle('is-scrollable-start', hasOverflow && scrollLeft > 1);
  filterEl.classList.toggle('is-scrollable-end', hasOverflow && scrollLeft < maxScroll - 1);
}

function initFilterScrollHint(rootEl) {
  const filterEl = rootEl.querySelector('.filter-press__filter');
  const navEl = rootEl.querySelector('[data-filter-press-filter-nav]');

  if (!filterEl || !navEl) {
    return;
  }

  const update = () => {
    updateFilterScrollHint(navEl, filterEl);
  };

  navEl.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  MEDIA_QUERIES.lg.addEventListener('change', update);

  update();
}

function updateCardVisibility(cards, activeFilter, visibleCount) {
  const matchingCards = getVisibleCards(cards, activeFilter);

  cards.forEach((card) => {
    const isMatch = matchingCards.includes(card);
    const isVisible = isMatch && matchingCards.indexOf(card) < visibleCount;

    card.hidden = !isVisible;
    card.classList.toggle('filter-press__card--hidden', !isVisible);
  });

  return matchingCards.length > visibleCount;
}

function initCardPress(rootEl) {
  const filterButtons = Array.from(rootEl.querySelectorAll('[data-filter-press-filter-btn]'));
  const cards = Array.from(rootEl.querySelectorAll('[data-filter-press-card]'));
  const moreContainer = rootEl.querySelector('[data-filter-press-more]');
  const moreBtn = rootEl.querySelector('[data-filter-press-more-btn]');

  initFilterScrollHint(rootEl);

  if (!cards.length) {
    return;
  }

  let activeFilter = 'all';
  let visibleCount = getPageSize();

  const updateView = () => {
    const hasMore = updateCardVisibility(cards, activeFilter, visibleCount);

    if (moreContainer) {
      moreContainer.hidden = !hasMore;
    }
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.filter || 'all';
      visibleCount = getPageSize();
      setActiveFilterButton(filterButtons, button);
      updateView();
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      visibleCount += getPageSize();
      updateView();
    });
  }

  const handleBreakpointChange = () => {
    updateView();
  };

  MEDIA_QUERIES.sm.addEventListener('change', handleBreakpointChange);
  MEDIA_QUERIES.lg.addEventListener('change', handleBreakpointChange);

  updateView();
}

function initAll() {
  document.querySelectorAll('[data-filter-press]').forEach(initCardPress);
}

document.addEventListener('DOMContentLoaded', () => {
  initAll();
});
